import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'exclamation-circle-icon',
  templateUrl: './exclamation-circle-icon.component.html',
  styles: [':host { line-height: 0; }'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ExclamationCircleIconComponent {}
